import { render, staticRenderFns } from "./_base-split-button.vue?vue&type=template&id=3c876d52&scoped=true&"
import script from "./_base-split-button.vue?vue&type=script&lang=js&"
export * from "./_base-split-button.vue?vue&type=script&lang=js&"
import style0 from "./_base-split-button.vue?vue&type=style&index=0&id=3c876d52&scoped=true&lang=sass&"
import style1 from "./_base-split-button.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c876d52",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VMenu,VProgressCircular,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c876d52')) {
      api.createRecord('3c876d52', component.options)
    } else {
      api.reload('3c876d52', component.options)
    }
    module.hot.accept("./_base-split-button.vue?vue&type=template&id=3c876d52&scoped=true&", function () {
      api.rerender('3c876d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-split-button.vue"
export default component.exports